import React from 'react';
import { useIntl } from 'react-intl';
import messages from './FieldMessages';
import { formatListValue } from '../../../../shared/components/FormattedListValue';
import EnumChange from './EnumChange';
import FieldChange from './FieldChange';

const AuthorizationPropertyChange = props => {
  const intl = useIntl();
  const { log, users, relations, templates, ownCompanies, salutations } = props;

  const isEnum = () => {
    const value = log.oldValue.Value || log.newValue.Value;
    return value && value.hasOwnProperty('Value') && value.hasOwnProperty('Name');
  };

  const displayLogLine = () => {
    const transformedLogLine = {
      ...log,
      oldValue: log.oldValue.Value,
      newValue: log.newValue.Value,
    };

    if (isEnum()) {
      return <EnumChange log={transformedLogLine} />;
    }

    return <FieldChange log={transformedLogLine} users={users} relations={relations} />;
  };

  const message =
    log.oldValue.Name >= 0
      ? messages.AuthorizationPropertyWithName
      : messages.AuthorizationProperty;

  return (
    <span>
      {displayLogLine()}{' '}
      {intl.formatMessage(message, {
        name: formatListValue({ id: log.oldValue.Name, list: 'AuthorizationName', intl }),
        b: value => <b>{value}</b>,
      })}
    </span>
  );
};

export default AuthorizationPropertyChange;
